// ============================================================================
// Service consultation form — populate `#from-page` hidden field
// ----------------------------------------------------------------------------
// The CF7 form has a hidden input `#from-page`. We fill it with the hero
// section title so each submission carries which service page the lead
// came from (e.g. "Frequently asked questions", "Residential", etc.).
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const fromPageInput = document.querySelector("#from-page");
  const heroTitle = document.querySelector(".service-hero__title");

  if (!fromPageInput || !heroTitle) return;

  fromPageInput.value = heroTitle.innerText.trim();
});
